<div *ngIf="visible" class="ann-banner" role="status" aria-live="polite">
  <div class="ann-banner__body">
    <lucide-icon name="sparkles" [size]="16" class="ann-banner__icon"></lucide-icon>
    <div class="ann-banner__text">
      <span class="ann-banner__headline">Nueva funcionalidad disponible</span>
      <span class="ann-banner__sub">
        Descubre nuestros agentes de <strong>voz IA</strong>.
      </span>
    </div>

  </div>
  <a [routerLink]="'/agents'" [queryParams]="{ tenant: tenantId }" class="ann-banner__cta">
    Descubrir
    <lucide-icon name="arrow-right" [size]="12"></lucide-icon>
  </a>
  <button
    type="button"
    class="ann-banner__close"
    aria-label="Cerrar aviso"
    (click)="dismiss()"
  >
    <lucide-icon name="x" [size]="14"></lucide-icon>
  </button>
</div>
